import { render } from "./whousComponent.vue?vue&type=template&id=2b510e34"
import script from "./whousComponent.vue?vue&type=script&lang=js"
export * from "./whousComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__